/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'

function Pagination({ setting }) {
  const { size, page, setpage } = setting
  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-center">
        <li className="page-item">
          <a className="page-link border-0" href="/list">
            <span
              className="svgIcon"
              style={{
                maskImage: `url('/images/arrow-left.svg')`,
              }}
            >
              Previous
            </span>
          </a>
        </li>
        {Array.from({ length: size }).map((value, index) => (
          <li className="page-item">
            <a
              className={`page-link ${page === index + 1 ? 'active' : ''}`}
              onClick={() => setpage(index + 1)}
            >
              {index + 1}
            </a>
          </li>
        ))}
        {/* <li className="page-item">
          <a className="page-link active" href="/list">
            1
          </a>
        </li>
        <li className="page-item">
          <a className="page-link" href="/list">
            2
          </a>
        </li>
        <li className="page-item">
          <a className="page-link" href="/list">
            3
          </a>
        </li> */}
        <li className="page-item">
          <a className="page-link border-0" href="/list">
            <span
              className="svgIcon"
              style={{
                maskImage: `url('/images/arrow-right.svg')`,
              }}
            >
              next
            </span>
          </a>
        </li>
      </ul>
    </nav>
  )
}

Pagination.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Pagination
